var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9370_25311)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "url(#paint0_linear_9370_25311)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1916 56.3311L50.3769 55.2364C53.5371 36.3922 69.5087 38.0341 72.6768 38.5548C73.145 38.6317 73.406 38.6953 73.406 38.6953L74.3316 38.9156L74.2466 39.8639C74.2148 40.208 73.3993 48.3612 67.0798 53.2916C63.046 56.4422 57.7305 57.5198 51.284 56.5047L50.1916 56.3311Z",
    fill: "url(#paint1_linear_9370_25311)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4297 56.9844L42.3287 56.8932C35.8368 56.3458 30.9325 54.0321 27.7517 50.0064C22.7715 43.7081 23.8887 35.5794 23.9383 35.237L24.0749 34.294L25.0278 34.3004C25.0278 34.3004 25.2961 34.3007 25.7656 34.3371C28.9654 34.5851 44.8526 36.791 43.509 55.8756L43.4297 56.9844Z",
    fill: "url(#paint2_linear_9370_25311)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3337 107.925V49.3651C57.1622 49.3534 56.9935 49.3534 56.822 49.3534H39.7054V107.925H57.3337ZM35.3187 107.925H39.7054V49.3651H39.6095C32.5164 49.3651 26.2895 55.1895 25.7779 62.3011L23.3796 95.0038C22.8534 102.101 28.2285 107.925 35.3187 107.925ZM61.1099 107.925C68.2031 107.925 73.5752 102.101 73.052 94.9891L70.6508 62.2894C70.1391 55.3504 64.1943 49.6372 57.322 49.3651V107.925H61.1099Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9370_25311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 18,
    width: 19,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8302 18.7518L58.4137 20.2048L55.6591 50.4844L40.0756 49.0314L42.8302 18.7518Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9370_25311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3764 49.3129L46.7101 48.4258C42.7795 43.195 41.2267 37.9774 42.0942 32.9175C43.4514 24.9946 50.2344 20.4285 50.5238 20.2407L51.3165 19.7141L51.9463 20.434C52.1763 20.6924 57.5242 26.9064 56.7614 34.9101C56.2748 40.0218 53.4127 44.6396 48.2539 48.6355L47.3764 49.3129Z",
    fill: "url(#paint3_linear_9370_25311)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9370_25311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 45,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9043 45.351H72.5617V68.1513H49.9043V45.351Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9370_25311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9370_25311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 45,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2356 45.3558C54.9767 45.3558 49.9069 50.4577 49.9069 56.756C49.9069 63.0514 54.9767 68.1562 61.2356 68.1562C67.4915 68.1562 72.5643 63.0514 72.5643 56.756C72.5643 50.4577 67.4915 45.3558 61.2356 45.3558Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9370_25311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9069 45.3558H72.5643V68.1562H49.9069V45.3558Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9370_25311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 45,
    width: 23,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.016 45.351H44.6734V68.1513H22.016V45.351Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9370_25311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9370_25311",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 45,
    width: 23,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3473 45.3558C27.0884 45.3558 22.0186 50.4577 22.0186 56.756C22.0186 63.0514 27.0884 68.1562 33.3473 68.1562C39.6032 68.1562 44.6759 63.0514 44.6759 56.756C44.6759 50.4577 39.6032 45.3558 33.3473 45.3558Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9370_25311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0186 45.3558H44.6759V68.1562H22.0186V45.3558Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2253 49.627C57.3212 49.627 54.1583 52.8098 54.1583 56.7385C54.1583 60.6644 57.3212 63.8472 61.2253 63.8472C65.1265 63.8472 68.2894 60.6644 68.2894 56.7385C68.2894 52.8098 65.1265 49.627 61.2253 49.627Z",
    fill: "#3D1F1E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.337 49.627C29.4329 49.627 26.27 52.8098 26.27 56.7385C26.27 60.6644 29.4329 63.8472 33.337 63.8472C37.2382 63.8472 40.4011 60.6644 40.4011 56.7385C40.4011 52.8098 37.2382 49.627 33.337 49.627Z",
    fill: "#3D1F1E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7293 54.462C61.7293 52.9883 60.5401 51.7937 59.0733 51.7937C57.6064 51.7937 56.4172 52.9883 56.4172 54.462C56.4172 55.9356 57.6064 57.1302 59.0733 57.1302C60.5401 57.1302 61.7293 55.9356 61.7293 54.462Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9521 54.462C37.9521 52.9883 36.7629 51.7937 35.296 51.7937C33.8292 51.7937 32.64 52.9883 32.64 54.462C32.64 55.9356 33.8292 57.1302 35.296 57.1302C36.7629 57.1302 37.9521 55.9356 37.9521 54.462Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2082 74.702C48.695 72.3263 41.4803 74.1809 38.7506 75.5579C38.2065 75.8323 37.8388 76.3424 37.7019 76.9362C37.1034 79.5308 36.9157 84.628 43.928 84.041C52.5304 83.3208 55.8803 85.3751 58.5363 80.7056C60.6611 76.9701 58.3149 75.1467 57.2082 74.702Z",
    fill: "#3D1F1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1163 83.9467C41.6001 80.064 53.0078 80.5089 58.0466 81.52C57.4419 82.1266 56.8373 83.9467 53.2094 83.9467C45.9535 83.9468 42.9303 84.5534 41.1163 83.9467Z",
    fill: "#FA5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9370_25311",
    x1: 0.00000171925,
    y1: 184.555,
    x2: 98,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9370_25311",
    x1: 63.9972,
    y1: 37.1283,
    x2: 60.5612,
    y2: 58.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9370_25311",
    x1: 34.5257,
    y1: 35.0162,
    x2: 32.886,
    y2: 56.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9370_25311",
    x1: 51.318,
    y1: 19.7143,
    x2: 47.2983,
    y2: 49.3023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9370_25311"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 98,
    rx: 49,
    transform: "rotate(-90 0 98)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoProfile);
export default __webpack_public_path__ + "static/media/pikkoProfile.50d9c55f52e0b690ddc68fa02cfef4f9.svg";
export { ForwardRef as ReactComponent };